export default {
  CHANGED: 'PROMPT_CHANGED'
}
